module.exports = __webpack_public_path__ + "img/ogLogo.53d4340e.png";